"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _eventemitter = require("eventemitter2");

var _util = require("./util");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Device = function (_EventEmitter) {
  _inherits(Device, _EventEmitter);

  function Device(input, name) {
    var opts = arguments.length <= 2 || arguments[2] === undefined ? { globalMidiChannel: false } : arguments[2];

    _classCallCheck(this, Device);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Device).call(this, {
      wildcard: true,
      delimiter: ":"
    }));

    _this.input = input;
    _this.name = name;
    _this.opts = opts;

    _this.codes = {};
    _this.default = {
      type: "analog"
    };

    switch ((0, _util.getEnv)()) {
      case "browser":
        _this.input.onmidimessage = function (msg) {
          _this.emit("midi:message", Array.prototype.slice.call(msg.data));
        };
        break;
      case "nodejs":
        _this.input.on("message", function (deltaTime, msg) {
          _this.emit("midi:message", msg);
        });
        break;
    }

    _this.on("midi:message", function (msg) {
      _this.debug(msg);
      var e = _this.codes[opts.globalMidiChannel ? msg[0] + "," + msg[1] : msg[1]];
      if (!e) {
        return;
      }
      if (e.type === "digital") {
        _this.emit(e.name, msg[2] > 0);
      } else {
        _this.emit(e.name, msg[2]);
      }
    });
    return _this;
  }

  _createClass(Device, [{
    key: "close",
    value: function close() {
      this.debug("closePort");
      this.input.closePort();
    }
  }, {
    key: "register",
    value: function register(code, opts) {
      var _this2 = this;

      Object.keys(this.default).forEach(function (key) {
        if (!opts.hasOwnProperty(key)) {
          opts[key] = _this2.default[key];
        }
      });
      if (code instanceof Array) {
        code = code.join(",");
      }
      this.codes[code] = opts;
    }
  }, {
    key: "button",
    value: function button(code, name) {
      var opts = {
        name: "button:" + name,
        type: "digital"
      };
      this.register(code, opts);
    }
  }, {
    key: "knob",
    value: function knob(code, name) {
      var opts = { name: "knob:" + name };
      this.register(code, opts);
    }
  }, {
    key: "slider",
    value: function slider(code, name) {
      var opts = { name: "slider:" + name };
      this.register(code, opts);
    }
  }]);

  return Device;
}(_eventemitter.EventEmitter2);

exports.default = Device;
//# sourceMappingURL=data:application/json;base64,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


/*****************
 ** WEBPACK FOOTER
 ** ./~/korg-nano-kontrol/lib/device.js
 ** module id = 14
 ** module chunks = 2
 **/